@if (loaded()) {
  <hyperkit-dialog class="hyperkit-component" headerText="Edit Hunt">
    <div class="container-fluid">
      <div class="row">
        <div class="container">
          <form
            class="k-form"
            [formGroup]="formGroup"
            autocomplete="off"
            (ngSubmit)="onSubmit()"
          >
            <kendo-formfield>
              <label for="name">Hunt Name*</label>
              <input
                id="name"
                formControlName="name"
                maxlength="50"
                kendoTextBox
              />
              <kendo-formerror>Error: Name is required</kendo-formerror>
            </kendo-formfield>
            <kendo-formfield>
              <label for="environments">Environments*</label>
              <kendo-multiselect
                [data]="environments"
                textField="name"
                valueField="id"
                placeholder="Environments"
                formControlName="environments"
                (removeTag)="removeTag($event)"
                (valueChange)="onValueChange($event)"
              >
              </kendo-multiselect>
              <kendo-formerror>Error: Environment is required</kendo-formerror>
            </kendo-formfield>
            <div class="k-two-col">
              <kendo-formfield>
                <label for="priority">Priority</label>
                <kendo-dropdownlist
                  value="{{ hunt.priority }}"
                  [valuePrimitive]="true"
                  formControlName="priority"
                  [data]="priorities"
                >
                </kendo-dropdownlist>
              </kendo-formfield>
              <kendo-formfield>
                <label for="assignee">Assignee</label>
                <kendo-dropdownlist
                  textField="fullName"
                  valueField="id"
                  formControlName="assignee"
                  [data]="assignees$ | async"
                >
                </kendo-dropdownlist>
              </kendo-formfield>
            </div>
            <hyperkit-button
              size="small"
              [disabled]="!formGroup.valid"
              color="tertiary"
              text="Save"
              type="submit"
            ></hyperkit-button>
          </form>
        </div>
      </div>
    </div>
  </hyperkit-dialog>
} @else {
  <p>Loading…</p>
}
